function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import PropTypes from 'prop-types';
import { WDHLocationsSpot, GoogleMap, Search, withTempSelection } from './../../../custom-components/wdh-locations-spot';
import defaultPropTypes from './../../../custom-components/wdh-locations-spot/src/js/utils/prop-types';
// eslint-disable-next-line no-unused-vars
import GTMTracking from './../../../custom-components/wdh-locations-spot/src/js/utils/gtm-tracking';
import { onResize, getAll } from './../../../../../wdh-foundation/wdh';
import OticonLocationDetail from './../../../custom-components/wdh-locations-spot/src/js/views/location-detail';
import OticonLocationListView from './../../../custom-components/wdh-locations-spot/src/js/views/location-list-view';
var OticonLocationMarker = function OticonLocationMarker(props) {
  var dataSet = {};
  var keys = Object.keys(props.location);
  keys.forEach(function (key) {
    var dataName = "data-".concat(key.toLowerCase());
    var dataValue = props.location[key];
    dataSet[dataName] = dataValue;
  });
  return /*#__PURE__*/React.createElement("div", _extends({
    className: "location-marker ".concat(props.selectedClass),
    onClick: props.onClick,
    role: "presentation"
  }, dataSet));
};
OticonLocationMarker.propTypes = {
  location: defaultPropTypes.location.isRequired,
  selectedClass: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired
};
var OticonSearchLocationMarker = function OticonSearchLocationMarker() {
  return /*#__PURE__*/React.createElement("div", {
    className: "search-location-marker icomoon icon-location-pin-map2"
  });
};
var OticonUserLocationMarker = function OticonUserLocationMarker() {
  return /*#__PURE__*/React.createElement("div", {
    className: "user-location-marker icomoon icon-location-pin-map2"
  });
};
var locationsSpot = new WDHLocationsSpot();
locationsSpot.calculateHeight = function () {
  var headerHeight = document.querySelector('.header').offsetHeight;
  var windowHeight = window.innerHeight;
  return Math.floor(windowHeight - headerHeight) - 2;
};
var locationSearch = /*#__PURE__*/React.createElement(Search, {
  key: "search"
});
var expandMap = /*#__PURE__*/React.createElement(Search, {
  key: "search"
});
// DESKTOP LAYOUT
locationsSpot.addDesktopView(/*#__PURE__*/React.createElement(OticonLocationListView, {
  key: "list",
  header: [locationSearch],
  listDetailView: OticonLocationDetail
}));
locationsSpot.addDesktopView(/*#__PURE__*/React.createElement(GoogleMap, {
  key: "map",
  locationMarker: OticonLocationMarker,
  userLocationMarker: OticonUserLocationMarker,
  searchMarker: OticonSearchLocationMarker
}));

// MOBILE LAYOUT
locationsSpot.addMobileView(expandMap);
locationsSpot.addMobileView(/*#__PURE__*/React.createElement(GoogleMap, {
  key: "map",
  locationMarker: OticonLocationMarker,
  userLocationMarker: OticonUserLocationMarker,
  searchMarker: OticonSearchLocationMarker
}));
locationsSpot.addMobileView(/*#__PURE__*/React.createElement(OticonLocationListView, {
  key: "list",
  listDetailView: OticonLocationDetail
}));
locationsSpot.shouldReSortListOnMapChange = true;
locationsSpot.autoHeightOnMobileDetailView = true;

// stop running if find external usage component

var runLocationSpot = function runLocationSpot(customClass) {
  return customClass ? locationsSpot.run() : locationsSpot.run(customClass);
};
if (!document.querySelector('.locations-spot.external-usage')) {
  runLocationSpot();
}
onResize(function () {
  // WAIT FOR EVERYTHING TO RENDER, THEN ADD SOME NEGATIVE MARGIN TO
  // GOOGLE AUTO COMPLETE TO MITIGATE THE MARGIN ON #CONTENT
  setTimeout(function () {
    var pacContainer = getAll('.pac-container');
    var content = document.querySelector('#content');
    pacContainer.forEach(function (elem) {
      elem.style.marginTop = "-".concat(content.style.marginTop);
    });
  }, 500);
});
var getLocationSpotExternalComponent = function getLocationSpotExternalComponent() {
  var $element = document.querySelector('.locations-spot.external-usage');
  $element.classList.add('prevent-running');
  if ($element) {
    var outerHtml = $element.outerHTML;
    return outerHtml;
  }
};
window.runLocationSpot = runLocationSpot;
window.getLocationSpotExternalComponent = getLocationSpotExternalComponent;